module.exports = __webpack_public_path__ + "static/img/維夫拉克.dec9432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/合作夥伴/維夫拉克.jpg?20181011
// module id = Ny0h
// module chunks = 1